import { render } from "./Profile-user.vue?vue&type=template&id=e18dc4b2"
import script from "./Profile-user.vue?vue&type=script&lang=js"
export * from "./Profile-user.vue?vue&type=script&lang=js"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__